/* eslint-disable no-unused-vars */
import { EHttpMethods } from "../../../../enums";
import {
  AUTH_BASE_URL,
  PAYMENT_BASE_URL,
  PAYMENT_BASE_URL_V2,
  GET_TRANSACTION,
  GET_BANKS_INFO,
  PAYMENT_URL_V2,
} from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";
import { IOrganizationBankInfoResponse } from "../organization/models";
import { CHECKOUT_PATH } from "./constants";

import {
  IBankResponse,
  IBankTransferBody,
  IBankTransferResponse,
  ICashoutRequest,
  ICashoutResponse,
  ICheckoutRequest,
} from "./models";

const defaultProvide = async () => await getToken();

export const getCheckoutId = (
  data: ICheckoutRequest
): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL}${CHECKOUT_PATH}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, data);
};

export const getBankTransferDetails = (id: string): Promise<any> => {
  const url = `${PAYMENT_BASE_URL_V2}referenceTransactionId/${id}/bank-transfer-info`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const makeCashOutPayment = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}cashout?referenceTransactionId=${body.referenceTransactionId}&amount=${body.amount}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const revertTransaction = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}${body.referenceTransactionId}/revert`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const checkCashoutPayment = (
  referenceTransactionId: string,
  beneficiaryId: string | number
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}cashout/${referenceTransactionId}/status?beneficiaryId=${beneficiaryId}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const checkUserBank = (userId): Promise<IBankResponse> => {
  const url = `${AUTH_BASE_URL}${GET_BANKS_INFO(userId)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getOrgOwnerBanks = (
  userId
): Promise<IOrganizationBankInfoResponse> => {
  const url = `${AUTH_BASE_URL}/v2${GET_BANKS_INFO(userId)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getTransaction = (page = 0, size = 10): Promise<any> => {
  const url = `${PAYMENT_BASE_URL}${GET_TRANSACTION}?page=${page}&size=${size}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const settlePayment = (orderNumber: string): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}${orderNumber}/settle`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const makeBankTransfer = (
  body: IBankTransferBody
): Promise<IBankTransferResponse> => {
  const url = `${PAYMENT_URL_V2}`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};
